<template>
  <Badge :variant="labelColorCoding" :size="small ? 'small' : 'medium'" :label="props.status" :dot="true" />
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { Badge } from '@tallo/design-system';
import { PropertyStatus } from '@tallo/property';

import { propertyStatusVariant } from '../utils/property-status.util';

const props = defineProps<{
  status: PropertyStatus;
  small?: boolean;
}>();

const labelColorCoding = computed(() => propertyStatusVariant(props.status));
</script>
